export const TIPO_DOCUMENTO_COMERCIAL = {
  COMPRA: 0,
  VENTA: 1,
} as const

export type TipoDocumentoComercialType =
  (typeof TIPO_DOCUMENTO_COMERCIAL)[keyof typeof TIPO_DOCUMENTO_COMERCIAL]
